<template>
  <div class="title">
    <h1>{{ main }} <span>{{ des }}</span></h1>
  </div>
</template>

<script>
export default {
  props: {
    main: String,
    des: String
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/variables.scss';

.title {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 22px;

  @media only screen and (min-width: $break-m) {
    justify-content: flex-start;
  }

  h1 {
    font-family: 'DB HelvethaicaMon X';
    font-size: 1.5rem;

    @media only screen and (min-width: $break-m) {
      font-size: 2.5rem;
    }

    span {
      margin-left: 8px;
      padding-left: 8px;
      border-left: 1px solid #EEE;
      color: #BBB;
    }
  }
}
</style>
